module.exports = __webpack_public_path__ + "img/andteacher.05553a98.png";